import { getAnalytics } from "firebase/analytics";
import { initializeApp } from "firebase/app";
import { getFirestore } from "firebase/firestore";

const firebaseConfig = {
  apiKey: "AIzaSyA_weV-LnH4J679n0LOwvjeCsizF7teI3M",
  authDomain: "scantaps.firebaseapp.com",
  projectId: "scantaps",
  storageBucket: "scantaps.firebasestorage.app",
  messagingSenderId: "809913696973",
  appId: "1:809913696973:web:540803d3b89f46e8141f84",
  measurementId: "G-ZYV00E1CX2",
};

const app = initializeApp(firebaseConfig);
const analytics = getAnalytics(app);
const db = getFirestore(app);

export { db };
